export default async function (response) {
    if (response.status === 401) {
        await navigateTo('/login', { replace: true, redirectCode: 401 })
    }
    if (response.status >= 500) {
        useToast().add({
            title: 'Oups, on dirait que quelque chose a mal tourné... ',
            description: 'Nous avons été alertés et nous allons chercher à résoudre le problème. Si cela persiste, n\'hésitez pas à nous contacter !',
            icon: 'i-ph-warning-octagon-duotone',
            color: 'red'
        })
    }
}